import * as BufferGeometryUtils from "three/examples/jsm/utils/BufferGeometryUtils.js";
import { ringModel } from './models/rings/6.stl.js';

/*
import { ringModel as ringModel3 } from './models/rings/3.stl.js';
import { ringModel as ringModel4 } from './models/rings/4.stl.js';
import { ringModel as ringModel5 } from './models/rings/5.stl.js';
import { ringModel as ringModel6 } from './models/rings/6.stl.js';
import { ringModel as ringModel7 } from './models/rings/7.stl.js';
import { ringModel as ringModel8 } from './models/rings/8.stl.js';
import { ringModel as ringModel9 } from './models/rings/9.stl.js';
import { ringModel as ringModel10 } from './models/rings/10.stl.js';
import { ringModel as ringModel11 } from './models/rings/11.stl.js';
import { ringModel as ringModel12 } from './models/rings/12.stl.js';

const allRingModels = {
  3:ringModel3,
  4:ringModel4,
  5:ringModel5,
  6:ringModel6,
  7:ringModel7,
  8:ringModel8,
  9:ringModel9,
  10:ringModel10,
  11:ringModel11,
  12:ringModel12,
};
*/

import { STLLoader } from 'three/examples/jsm/loaders/STLLoader.js';

const tseg = 8;
const radseg = 15;

export const getOuterCircleGeo = (THREE, outerRadius, circleRatio, height, segments, lineToCircleHeight) => {

  const extrudeSettings = {
    depth: height,
    bevelEnabled: false,
    curveSegments: segments
  };

  let innerRadius = outerRadius / circleRatio;

  const outerCircle = new THREE.Shape();
  outerCircle.moveTo(outerRadius, 0);
  outerCircle.absarc(0, 0, outerRadius, 0, Math.PI * 2, false);

  const holePath = new THREE.Path();
  holePath.moveTo(innerRadius, 0);
  holePath.absarc(0, 0, innerRadius, 0, Math.PI * 2, true);

  outerCircle.holes.push(holePath);

  const extrudeCircle = new THREE.ExtrudeGeometry(outerCircle, extrudeSettings);
  return extrudeCircle;
}

export const getLineGeometry = (THREE, outerRadius, thicknessRatio, segments, shape, height, lineToCircleHeight) => {

  let lineHeight = height * lineToCircleHeight;
  const lineExtrudeSettings = {
    depth: lineHeight,
    bevelEnabled: false,
    curveSegments: segments
  };

  // start drawing the first line
  const lineShape = new THREE.Shape();

  //********* INstead it's: 2,3,4,1,1,3 4.... wtf??!?
  lineShape.moveTo(shape["x1"], shape["y1"])
  lineShape.lineTo(shape["x2"], shape["y2"])
  lineShape.lineTo(shape["x3"], shape["y3"])
  lineShape.lineTo(shape["x4"], shape["y4"])
  lineShape.lineTo(shape["x1"], shape["y1"])

  const lineGeo = new THREE.ExtrudeGeometry(lineShape, lineExtrudeSettings);

  return lineGeo;
}

export const getTorusGeometry = (THREE, finalBailThickness, finalBailDiameter, outerRadius, height, tseg, radseg, finalDiameter, bailPositionOffset) => {


  let diameterRatio = finalDiameter / outerRadius;
  let scale = outerRadius * diameterRatio;
  // get the dimenstions of the torus
  let computed_bail_thickness = finalBailThickness / scale;
  let computed_bail_radius = (finalBailDiameter / 2) / scale;

  // make the geometry
  const torus = new THREE.TorusGeometry(computed_bail_radius, computed_bail_thickness, tseg, radseg);

  // position the torus
  let torusX = 0;
  let torusY = -outerRadius - computed_bail_radius + (computed_bail_thickness / bailPositionOffset);
  let torusZ = height / 2;

  torus.translate(torusX, torusY, torusZ);

  return torus;
};

const calcChartGeo = (THREE, size, aspects, outerRadius, finalDiameter, lineThicknessRatio, circleRatio, thicknessRatio, lineToCircleHeight) => {

  let segments;
  const aspectsArr = JSON.parse(JSON.stringify(aspects));

  if (size === 'small') {
    segments = 50;
  } else if (size === 'medium') {
    segments = 70;

  } else {
    segments = 90;

  }

  let height = outerRadius / thicknessRatio;

  const geos = [];

  const circleGeometry = getOuterCircleGeo(THREE, outerRadius, circleRatio, height, segments, lineToCircleHeight);

  geos.push(circleGeometry);

  const firstLineGeo = getLineGeometry(THREE, outerRadius, thicknessRatio, segments, aspectsArr.pop()["shape"], height, lineToCircleHeight);

  geos.push(firstLineGeo);


  for (let i = 0; i < aspectsArr.length; i++) {
    const shape = aspectsArr[i]["shape"];

    const lgeo = getLineGeometry(THREE, outerRadius, thicknessRatio, segments, shape, height, lineToCircleHeight);

    geos.push(lgeo);
  }

  return geos;
};

export const calcNecklaceGeo = ({ THREE, size, aspects, outerRadius, finalDiameter, lineThicknessRatio, circleRatio, thicknessRatio, lineToCircleHeight, finalBailThickness, finalBailDiameter, bailPositionOffset }) => {

  let height = outerRadius / thicknessRatio;

  let diameterRatio = finalDiameter / outerRadius;

  // scale this down for the website
  let scale = outerRadius * diameterRatio * 0.2;

  const geos = calcChartGeo(THREE, size, aspects, outerRadius, finalDiameter, lineThicknessRatio, circleRatio, thicknessRatio, lineToCircleHeight)

  const torus = getTorusGeometry(THREE, finalBailThickness, finalBailDiameter, outerRadius, height, tseg, radseg, finalDiameter, bailPositionOffset);

  // this new version on THREE cannot have different attributes btwn geometries
  // https://discourse.threejs.org/t/how-to-use-mergebuffergeometries/13071/2
  // index was the attribute that's different btwn them
  // https://discourse.threejs.org/t/using-mergebuffergeometries-with-geometries-that-have-different-attributes/19166/4
  // this doesnt work:
  // geos.push( torus );
  geos.push(torus.toNonIndexed());

  const newGeo = BufferGeometryUtils.mergeGeometries(geos);
  return newGeo.scale(scale, scale, scale);

};


export const calcRingGeo = ({ THREE, size, aspects, outerRadius, finalDiameter, lineThicknessRatio, circleRatio, thicknessRatio, lineToCircleHeight, finalBailThickness, finalBailDiameter, bailPositionOffset }) => {
  let diameterRatio = finalDiameter / outerRadius;

  let height = outerRadius / thicknessRatio;
  let scale = outerRadius * diameterRatio;

  const geos = calcChartGeo(THREE, size, aspects, outerRadius, finalDiameter, lineThicknessRatio, circleRatio, thicknessRatio, lineToCircleHeight)

  geos.forEach(geo => geo.scale(scale, scale, scale));

  // this auto includes the circle, take it out
  geos.shift();

  const loader = new STLLoader();

  // use size to select one of the imported models
  //const ringModel = allRingModels[size];

  // to do dynamic binary import
  const stlGeo = loader.parse(ringModel)
  //let lineHeight = height * lineToCircleHeight;
  //stlGeo.translate( 0,0, lineHeight*scale);
  //stlGeo.setAttribute( 'uv', new THREE.Float32BufferAttribute( 'uv', [] ) );
  geos.push(stlGeo);

  for (let i = 0; i < geos.length; i += 1) {
    geos[i].deleteAttribute('uv');
  }

  const newGeo = BufferGeometryUtils.mergeGeometries(geos);

  // scale this down for the website
  let browserScale = outerRadius * diameterRatio * 0.2;
  return newGeo.scale(browserScale, browserScale, browserScale);
};

export const createModelMesh = ({ THREE, reflectionCube, meshKey, colorVal, aspects, ...settings }) => {

  let geo;

  if (settings.pieceType === 'pendant') {
    geo = calcNecklaceGeo({ THREE, size: meshKey, aspects, ...settings })
  }

  if (settings.pieceType === 'ring') {
    geo = calcRingGeo({ THREE, size: meshKey, aspects, ...settings })
  }

  var mat = new THREE.MeshPhongMaterial({
    color: colorVal,
    emissive: 0x0,
    envMap: reflectionCube,
    refractionRatio: 1,
    reflectivity: 0.7,
    shininess: 70,
    //,wireframe:true,transparent:true
  });

  var mesh = new THREE.Mesh(geo, mat);

  mesh.position.setY(4.5);
  mesh.position.setZ(-22.5);
  mesh.rotation.z = Math.PI;
  mesh.rotation.y -= 0.4;
  //mesh.castShadow = true; //default is false
  return mesh;

};
